
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-test-loader/-embroider-implicit-modules.js";
